import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=de18d488&"
import script from "./Promotion.vue?vue&type=script&lang=js&"
export * from "./Promotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports